import { __assign, __extends } from "tslib";
import React from 'react';
import { utils, optionsMap } from 'pro-gallery-lib';
import { shouldCreateVideoPlaceholder } from '../itemHelper';
import { VideoPlayButton } from '../media/playButton';
import MediaImage from '../media/mediaItem';
var isIos = utils.isiOS();
var useTransparentPlayButtonAndForceLoadVideo = function (props) {
    return (props.videoUrl || props.url).includes('youtube.com') && isIos;
};
var VideoItem = React.lazy(function () {
    return import(/* webpackChunkName: "proGallery_videoItem" */ './videoItem');
});
var VideoItemImplementation = /** @class */ (function (_super) {
    __extends(VideoItemImplementation, _super);
    function VideoItemImplementation() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    VideoItemImplementation.prototype.render = function () {
        var shouldForceLoadVideo = useTransparentPlayButtonAndForceLoadVideo(this.props);
        return (React.createElement(VideoItem, __assign({}, this.props, { loadVideo: this.props.shouldPlay || shouldForceLoadVideo, videoPlaceholder: this.props.thumbnail, videoPlayButton: this.props.showPlayButton && React.createElement(VideoPlayButton, null) })));
    };
    return VideoItemImplementation;
}(React.Component));
var VideoItemWrapper = /** @class */ (function (_super) {
    __extends(VideoItemWrapper, _super);
    function VideoItemWrapper() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    VideoItemWrapper.prototype.render = function () {
        var showVideoPlayButton = this.props.options[optionsMap.behaviourParams.item.video.enablePlayButton];
        return (React.createElement(MediaImage, __assign({}, this.props, { MediaImplementation: VideoItemImplementation, enableImagePlaceholder: shouldCreateVideoPlaceholder(this.props.options), showPlayButton: showVideoPlayButton, placeholderExtraClasses: ['video-item', 'gallery-item-video'] })));
    };
    return VideoItemWrapper;
}(React.Component));
export default VideoItemWrapper;
/* eslint-enable prettier/prettier */
//# sourceMappingURL=videoItemWrapper.js.map